import React from 'react';
import Container from './Container';

const ContainerContext = React.createContext<Container>(new Container());
export default ContainerContext;
